import axios, { InternalAxiosRequestConfig } from 'axios';

const FASTAPI_ENDPOINTS = [
  'api/v1/traps/floor',
  'api/v1/hubs/floor',
  'api/v1/hubs/site',
  'api/v1/traps/site',
  'api/v1/site',
  'api/v1/mct-heat-map',
  'api/v1/srst-heat-map',
  'api/v1/smst-heat-map',
  'api/v1/vulnerabilities/floor',
  'api/v1/encounters/floor',
  'api/v1/floorplans/',
  'api/v1/encounters/',
  'api/v1/encounters/charts/create_and_fix_encounters_per_month/',
  'api/v1/encounters/charts/unique_pests_per_day/',
  'api/v1/encounters/charts/pest_vs_traces_per_day/',
  'api/v1/traps/trap-activation-signals',
  'api/v1/traps/charts/pie_chart_by_enters',
  'api/v1/traps/charts/time_period_signals',
  'api/v1/traps/charts/pie_chart_by_activations',
  'api/v1/traps/activation-signals/',
  'api/v1/traps/charts/bait-activation-signals/object/',
  'api/v1/traps/bait-activation-signals/',
  'api/v1/traps/',
  'api/v1/objects/',
];

const axiosInterceptor = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});
const axiosInterceptorForMultipartFromData = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
axiosInterceptor.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  // Check if the request URL matches any FastAPI endpoint
  const isFastAPIEndpoint = FASTAPI_ENDPOINTS.some(endpoint => {
    // Remove leading /api if present in the URL
    const cleanUrl = config.url?.replace(/^\/api\//, '');
    return cleanUrl?.startsWith(endpoint);
  });

  // Set the appropriate base URL
  if (isFastAPIEndpoint) {
    // Fast API endpoints
    config.baseURL = process.env.REACT_APP_FASTAPI_URL;
    // Clean up the URL to prevent double api
    config.url = config.url?.replace(/^\/api\//, '');
  } else {
    // Django endpoints
    config.baseURL = process.env.REACT_APP_BACKEND_URL;
  }

  return config;
});

export default axiosInterceptor;
export { axiosInterceptorForMultipartFromData };
